export type ToastType = "success" | "error" | "info" | "warning";

export type ToastPayload = {
  type: ToastType;
  message: string;
  duration?: number;
};

let _showToast: ((p: ToastPayload) => void) | null = null;

export const toastService = {
  register(fn: (p: ToastPayload) => void) {
    _showToast = fn;
  },
  success(message: string, duration?: number) {
    _showToast?.({ type: "success", message, duration });
  },
  error(message: string, duration?: number) {
    _showToast?.({ type: "error", message, duration });
  },
  info(message: string, duration?: number) {
    _showToast?.({ type: "info", message, duration });
  },
  warning(message: string, duration?: number) {
    _showToast?.({ type: "warning", message, duration });
  },
};
